// Header presentation: preserve native actions and scroll ownership.
(function () {
  'use strict';
  function ready() {
    var header = document.getElementById('t_Header');
    var main = document.querySelector('.t-Body-main');
    if (!header || !main || header.classList.contains('lp-header-chrome')) { return; }
    function decorateActions() {
      header.querySelectorAll('.t-NavigationBar-item > .t-Button--navBar').forEach(function (button) {
        var icon = button.querySelector('.t-Icon');
        var label = button.querySelector('.t-Button-label');
        if (icon && icon.matches('.fal,.fas')) {
          icon.classList.remove('fal', 'fas');
          icon.classList.add('far');
        }
        var name = label ? label.textContent.trim() : '';
        if (button.closest('.lxTop_P')) { name = /^hr/i.test(document.documentElement.lang) ? 'Profil' : 'Profile'; }
        var badge = button.querySelector('.t-Button-badge');
        var count = badge ? badge.textContent.trim() : '';
        if (name) { button.title = name; button.setAttribute('aria-label', name + (count ? ' (' + count + ')' : '')); }
      });
    }
    decorateActions();
    var actions = header.querySelector('.t-Header-navBar');
    if (actions) { new MutationObserver(decorateActions).observe(actions, {childList:true,subtree:true}); }
    if (actions) {
      var compact = window.matchMedia('(max-width:480px)');
      var hr = /^hr/i.test(document.documentElement.lang);
      var more = document.createElement('button');
      more.type = 'button'; more.id = 'lp-header-more';
      more.className = 't-Button t-Button--navBar lp-header-more';
      more.title = hr ? 'Više' : 'More'; more.setAttribute('aria-label', more.title);
      more.setAttribute('aria-expanded', 'false'); more.setAttribute('aria-controls', 'lp-header-overflow');
      var moreIcon = document.createElement('span');
      moreIcon.className = 't-Icon far fawe-ellipsis-h'; moreIcon.setAttribute('aria-hidden', 'true');
      more.appendChild(moreIcon);
      var utilityBadge = document.createElement('span'); utilityBadge.className = 't-Button-badge';
      more.appendChild(utilityBadge);
      var panel = document.createElement('div');
      panel.id = 'lp-header-overflow'; panel.hidden = true;
      panel.setAttribute('role', 'group'); panel.setAttribute('aria-label', more.title);
      var list = document.createElement('ul'); list.className = 'lp-header-overflow-list'; panel.appendChild(list);
      var moved = [];
      ['#lp-app-appearance', '.lxTop_SP', '.lxTop_L'].forEach(function (selector) {
        var node = actions.querySelector(selector);
        if (!node) { return; }
        var marker = document.createComment('header utility position'); node.before(marker);
        var entry = node;
        if (node.id === 'lp-app-appearance') {
          entry = document.createElement('li'); entry.className = 't-NavigationBar-item';
          var text = document.createElement('span'); text.className = 'lp-header-action-label';
          node.appendChild(text);
          function appearanceLabel() { text.textContent = node.getAttribute('aria-label'); }
          document.addEventListener('lxp:appearance', appearanceLabel); appearanceLabel();
        }
        moved.push({node:node,marker:marker,entry:entry});
      });
      function updateUtilityBadge() {
        var count = moved.reduce(function (total, item) {
          var badge = item.node.querySelector('.t-Button-badge');
          return total + (badge ? parseInt(badge.textContent, 10) || 0 : 0);
        }, 0);
        utilityBadge.textContent = count ? String(count) : '';
        more.setAttribute('aria-label', more.title + (count ? ' (' + count + ')' : ''));
      }
      new MutationObserver(updateUtilityBadge).observe(list, {childList:true,subtree:true,characterData:true});
      function close(restoreFocus) {
        panel.hidden = true; more.setAttribute('aria-expanded', 'false');
        if (restoreFocus) { more.focus(); }
      }
      function arrange() {
        close(false);
        moved.forEach(function (item) {
          if (compact.matches) {
            if (item.entry !== item.node) { item.entry.appendChild(item.node); }
            list.appendChild(item.entry);
          } else {
            item.marker.after(item.node);
            if (item.entry !== item.node) { item.entry.remove(); }
          }
        });
      }
      more.addEventListener('click', function () {
        var open = panel.hidden; panel.hidden = !open; more.setAttribute('aria-expanded', String(open));
        if (open) { var first = panel.querySelector('button,a'); if (first) { first.focus(); } }
      });
      panel.addEventListener('click', function (event) {
        var control = event.target.closest('button,a');
        if (control) { close(control.id === 'lp-app-appearance'); }
      });
      document.addEventListener('click', function (event) {
        if (!panel.contains(event.target) && !more.contains(event.target)) { close(false); }
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); close(true); }
      });
      document.addEventListener('focusin', function (event) {
        if (!panel.hidden && !panel.contains(event.target) && event.target !== more) { close(false); }
      });
      actions.prepend(more); header.appendChild(panel);
      compact.addEventListener('change', arrange); arrange();
    }
    var queued = false;
    function update() {
      queued = false;
      var bounds = header.getBoundingClientRect();
      var start = Math.max(0, Math.min(bounds.width, main.getBoundingClientRect().left - bounds.left));
      header.style.setProperty('--lp-header-content-start', start + 'px');
      var scrolled = window.scrollY > 1 || Array.prototype.some.call(
        main.querySelectorAll('.t-Body-content, .t-Body-mainContent'),
        function (pane) { return pane.scrollTop > 1; }
      ) || main.scrollTop > 1;
      header.classList.toggle('lp-header-scrolled', scrolled);
    }
    function schedule() {
      if (!queued) { queued = true; requestAnimationFrame(update); }
    }
    header.classList.add('lp-header-chrome');
    // Capture nested native content-pane scrolling as well as viewport scrolling.
    // The computed state excludes the navigation tree and dialog scroll owners.
    document.addEventListener('scroll', schedule, {capture:true,passive:true});
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    new ResizeObserver(schedule).observe(main);
    new MutationObserver(schedule).observe(document.body, {attributes:true,attributeFilter:['class']});
    update();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', ready); }
  else { ready(); }
})();
